import { AxiosError } from "axios";
import { IErrorData } from "../api/services/types";

export const convertException = (e: unknown): IErrorData => {
  if (e instanceof AxiosError) {
    if (e.response?.data) {
      return {
        error: {
          ...(e.response.data as IErrorData).error,
          status: e.response.status,
        }
      } as IErrorData;
    }

    console.error("OOPS, unknown axios error.", e.response);
  } else {
    console.error("OOPS, unknown exception.", e);
  }

  return {
    error: {
      code: "UnknownError",
      message: "We could not process this request, please try again later.",
      status: 500,
    }
  } as IErrorData;
};
